<template>
  <div class="alert alert-info mt-4" role="alert">
    No data yet. <a href="/">Upload a CSV file</a> first, or try it with the
    <a href="/raw_data.csv" download>sample data</a>.
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss"></style>
